/* Keep sales order within each availability group, without duplicate products across pages. */
class AmaroCollectionFlow extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('#product-card-grid');
    if (!this.grid) return;
    this.models = new Map();
    this.pending = [];
    this.consume(Array.from(this.grid.children), !!this.querySelector('infinite-scroll'));
  }
  consume(cards, hasNext) {
    for (const card of cards) {
      const key = card.dataset.amaroProduct;
      if (!key) continue;
      const old = this.models.get(key);
      const available = card.dataset.amaroAvailable === 'true';
      if (old) { card.remove(); continue; }
      this.models.set(key, card);
      if (!available) {
        card.remove();
        this.pending.push(key);
      } else this.grid.append(card);
    }
    if (!hasNext) {
      for (const key of this.pending) {
        const card = this.models.get(key);
        if (card.dataset.amaroAvailable !== 'true') this.grid.append(card);
      }
      this.pending = [];
    }
    window.amaroHome?.initialize(this.closest('.amaro-home-section') || this);
    this.querySelector('amaro-collection-purchase')?.initializeCards();
  }
  appendPage(parsed) {
    const grid = parsed.querySelector('#product-card-grid');
    if (!grid) throw new Error('Missing collection grid');
    const next = parsed.querySelector('amaro-collection-flow .pagination-container');
    this.consume(Array.from(grid.children), !!next?.querySelector('infinite-scroll'));
    const current = this.querySelector('.pagination-container');
    if (next) current.replaceWith(next);
    else current?.remove();
  }
}
class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more]');
    this.status = this.querySelector('[data-load-status]');
    this.controller = new AbortController();
    this.button?.addEventListener('click', () => this.load(), { signal: this.controller.signal });
    window.addEventListener('online', () => { if (this.failed) this.load(); }, { signal: this.controller.signal });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting) && !this.failed) this.load();
      }, { rootMargin: '400px', threshold: 0 });
      this.observer.observe(this);
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
    this.observer?.disconnect();
  }
  async load() {
    if (this.loading || !this.isConnected) return;
    const flow = this.closest('amaro-collection-flow');
    if (!flow?.grid) return;
    this.loading = true;
    this.failed = false;
    this.button.disabled = true;
    this.button.textContent = 'Cargando…';
    this.status.textContent = '';
    this.request = new AbortController();
    const timeout = setTimeout(() => this.request.abort(), 15000);
    try {
      const url = new URL(this.dataset.url, window.location.href);
      url.searchParams.set('section_id', flow.grid.dataset.id);
      const response = await fetch(url, { signal: this.request.signal });
      if (!response.ok) throw new Error('Collection request failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!this.isConnected || this.closest('amaro-collection-flow') !== flow) return;
      flow.appendPage(parsed);
    } catch (error) {
      if (!this.isConnected) return;
      this.failed = true;
      this.button.disabled = false;
      this.button.textContent = 'Reintentar';
      this.status.textContent = 'No pudimos cargar más productos. Puedes volver a intentarlo.';
    } finally {
      clearTimeout(timeout);
      this.loading = false;
    }
  }
}
if (!customElements.get('amaro-collection-flow')) customElements.define('amaro-collection-flow', AmaroCollectionFlow);
if (!customElements.get('infinite-scroll')) customElements.define('infinite-scroll', InfiniteScroll);
